var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListIconActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 0H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1M2.25 9.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m0-3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m0-3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M10 9.5H4.5a.5.5 0 1 1 0-1H10a.5.5 0 0 1 0 1m0-3H4.5a.5.5 0 1 1 0-1H10a.5.5 0 0 1 0 1m0-3H4.5a.5.5 0 1 1 0-1H10a.5.5 0 0 1 0 1"
})));
export { SvgListIconActive as ReactComponent };
export default __webpack_public_path__ + "ef8d0ac0fc6c89e57dd7e7dd9da032c1.svg";